import { ReactNode, useCallback } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
// Mui
import { Badge, Box, IconButton } from "@mui/material";
// Components
import { IBasicMenuSlotProps } from "./AnimatedDropdownMenu";
import clsx from "clsx";

interface IHeaderActionsProps extends IBasicMenuSlotProps {
	id: string;
	iconButton: ReactNode;
	badgeNumber?: number;
	title?: () => string;
}

export const HeaderActionIconButton = ({
	id,
	dropdownElement,
	iconButton,
	badgeNumber,
	title,
	onMouseEnter,
	disabled = false,
}: Readonly<IHeaderActionsProps>) => {
	const { loading } = useSelector((state: RootState) => state.location);
	const handleMouseEnter: typeof onMouseEnter = useCallback((...args) => !loading && onMouseEnter(...args), [loading, onMouseEnter]);
	return (
		<div className="relative h-full" onMouseEnter={handleMouseEnter}>
			<IconButton
				disableRipple
				id={id}
				className={clsx("w-[50px] h-full", {
					"!cursor-pointer !transition-opacity !duration-[250ms] hover:drop-shadow-subtle-white": !loading && !disabled,
					"hover:drop-shadow-none !cursor-default !opacity-25": loading || disabled,
				})}
			>
				{badgeNumber ? (
					<Box title={title?.()}>
						<Badge badgeContent={badgeNumber} className="notification-badge">
							{iconButton}
						</Badge>
					</Box>
				) : (
					iconButton
				)}
			</IconButton>
			<div className="absolute -translate-x-0.5! right-0">{dropdownElement}</div>
		</div>
	);
};
